import { Handler, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    CatalogPage,
    CatalogPageResult,
    GetCatalogPageByPathApiParameter,
} from "@insite/client-framework/Services/CategoryService";
import {
    chain,
    DispatchCompleteLoadCatalogPage,
} from "@insite/client-framework/Store/Data/CatalogPages/Handlers/LoadCatalogPageByPath";

type Parameter = {
    path: string;
} & HasOnSuccess<CatalogPage>;
type Props = {
    apiParameter: GetCatalogPageByPathApiParameter;
    apiResult: CatalogPageResult;
};

type HandlerType = Handler<Parameter, Props>;

const DispatchCustomCompleteLoadCatalogPage: HandlerType = props => {
    props.dispatch({
        type: "Data/CatalogPages/CompleteLoadCatalogPage",
        model: props.apiResult.catalogPage,
        path: props.apiParameter.path,
    });

    if (props.apiResult.categoriesById) {
        props.dispatch({
            type: "Data/Categories/CompleteLoadCategoriesById",
            categoriesById: props.apiResult.categoriesById,
        });
        // Update Custom reducer to maintain catalog page categories
        (props as unknown as any).dispatch({
            type: "CustomCategories/CustomCompleteLoadCategoriesById",
            categoriesById: props.apiResult.categoriesById,
        });
    }
};

replaceInChain(chain, DispatchCompleteLoadCatalogPage, DispatchCustomCompleteLoadCatalogPage);
